import axios from './../api' // 倒入 api

//主动安全列表查询
const getActiveSafetyList = (data) => {
    return axios({
        url: '/api/as/config/list',
        method: 'POST',
        data
    })
}

//主动安全恢复默认
const restoreDefault = (asConfigId) => {
    return axios({
        url: `/api/as/config/default/${asConfigId}`,
        method: 'GET',
    })
}

//下发参数(列表)
const sendCommand = (data) => {
    return axios({
        url: `/api/as/config/send`,
        method: 'POST',
        data
    })
}

//获取主动安全详情
const getSetDetail = (asConfigId) => {
    return axios({
        url: `/api/as/config/${asConfigId}`,
        method: 'GET'
    })
}

//参数保存
const saveParams = (data) => {
    return axios({
        url: `/api/as/config`,
        method: 'PUT',
        data
    })
}

//本页签下发
const sendCurrentCommand = (data) => {
    return axios({
        url: `/api/as/config/current`,
        method: 'PUT',
        data
    })
}

//全部下发
const sendAllCommand = (data) => {
    return axios({
        url: `/api/as/config/all`,
        method: 'PUT',
        data
    })
}

//参考对象
const activeSafetyRefer = (asConfigId) => {
    return axios({
        url: `/api/as/config/reference/${asConfigId}`,
        method: 'GET'
    })
}

//风险证据库
const getRiskList = (data) => {
    return axios({
        url: `/api/as/evidence`,
        method: 'POST',
        data
    })
}

//主动安全组织树
const getAsOrgTree = () => {
    return axios({
        url: `/api/car/org/tree`,
        method: 'GET'
    })
}

//主动安全车辆列表
const getActiveSafetyCars = (data) => {
    return axios({
        url: `/api/as/car/orgIds`,
        method: 'POST',
        data
    })
}

//主动安全处置报表列表
const getRiskReport = (data) => {
    return axios({
        url: `/api/as/risk/report`,
        method: 'POST',
        data
    })
}

export default {
    getActiveSafetyList,
    restoreDefault,
    sendCommand,
    getSetDetail,
    saveParams,
    sendCurrentCommand,
    sendAllCommand,
    activeSafetyRefer,
    getRiskList,
    getAsOrgTree,
    getActiveSafetyCars,
    getRiskReport
}